<div class="offerwrapper acvis-elevation" (dragover)="dragOver($event)" (drop)="dropp($event)">
    <div class="offerheader">
        <span multilang class="offerheadertext"><b>Angebot Nr. {{index}}</b> {{title}}</span>
        <ng-container *ngIf="currentCustomer?.asPartner">
            <div class="actions">
                <mat-icon class="rmico mr3" (click)="setCommentModal()" matTooltip="Extra info">comment
                </mat-icon>
                <button [draggable]="true" class="drg mr3" matTooltip="Position ändern"
                    (dragstart)="dragStart($event, index)">
                    <svg _ngcontent-soh-c164="" width="24px" fill="currentColor" viewBox="0 0 24 24">
                        <path _ngcontent-soh-c164=""
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path _ngcontent-soh-c164="" d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </button>
                <mat-icon class="rmico" (click)="removeFromListF()" matTooltip="Angebot löchen">cancel
                </mat-icon>
            </div>
        </ng-container>
    </div>

    <div class="offerbody">
        <div class="offerimgwrapper">
            <img *ngIf="offer.image?.length > 0" src="{{offer.image}}" class="offerimg lazyload"
                alt="{{offer?.description}}">
        </div>

        <div class="offerOperator">
            <img src="{{'https://media.traffics-switch.de/vadata/logo/png/h50/' + (offer.operator.toLowerCase()) + '.png'}}"
                height="24px" alt="{{offer?.operator}}" class="lazyload">
            <span multilang style="font-weight: 500;width: 230px;text-align: end;"
                class="ellipsis">{{offer?.description}}</span>
        </div>
        <div class="offerschedule">
            <mat-icon class="unsetico">event</mat-icon>
            <span multilang class="offerscheduletext">
                <b>{{offer?.travelDate?.duration + ' Tage'}}</b>
                {{offer?.travelDate?.fromDate | date}} - {{offer?.travelDate?.toDate | date}}
            </span>
        </div>
        <div class="offerinfos">
            <div class="infobody">
                <div class="offerinfodet">
                    <mat-icon class="infoc" style="transform: translate(0px, -10px);">arrow_forward_ios</mat-icon>
                    <div style="display: flex;flex-direction: column;">
                        <span multilang style="margin-left: .3rem;"><span multilang
                                style="font-weight: 700;">Abholung</span> -
                            {{offer?.travelDate?.fromDate | date}}, {{offer?.pickUpTime}} Uhr</span>
                        <span multilang style="margin-left: .3rem;"><span multilang
                                style="font-size: .75rem;">Flughafen</span> -
                            {{booking?.realparam?.arrivalAirportList?.name}}
                            ({{booking?.realparam?.arrivalAirportList?.code}})</span>
                    </div>
                </div>
                <div class="offerinfodet">
                    <mat-icon class="infoc" style="transform: translate(0px, -10px);">arrow_back_ios</mat-icon>
                    <div style="display: flex;flex-direction: column;">
                        <span multilang style="margin-left: .3rem;"><span multilang
                                style="font-weight: 700;">Rückgabe</span> -
                            {{offer?.travelDate?.fromDate | date}}, {{offer?.pickUpTime}} Uhr</span>
                        <span multilang style="margin-left: .3rem;"><span multilang
                                style="font-size: .75rem;">Flughafen</span> -
                            {{booking?.realparam?.arrivalAirportList?.name}}
                            ({{booking?.realparam?.arrivalAirportList?.code}})</span>
                    </div>
                </div>
                <div class="offerinfodet" style="margin-top: .5rem;">
                    <mat-icon class="infoc">check_circle</mat-icon>
                    <span multilang style="margin-left: .3rem;">{{offer?.features?.adults}} Erwachsene</span>
                </div>
                <div class="offerinfodet">
                    <mat-icon class="infoc">check_circle</mat-icon>
                    <span multilang style="margin-left: .3rem;">{{offer?.features?.bigLuggage}} Gepäckstück
                        groß</span>
                </div>
                <ng-container *ngIf="offer?.features?.doors?.length > 0">
                    <div class="offerinfodet">
                        <mat-icon class="infoc">check_circle</mat-icon>
                        <span multilang style="margin-left: .3rem;">{{offer?.features?.doors}} Türen</span>
                    </div>
                </ng-container>
            </div>

            <ng-container *ngIf="booking?.extracomment?.length > 0">
                <div class="offerinfodet extrainfos" [matTooltip]="booking?.extracomment" matTooltipClass="matTooltip"
                    #reiserucktritttr="matTooltip" (click)="reiserucktritttr.toggle();$event.stopPropagation();">
                    <span multilang>Extra info</span>
                    <mat-icon class="infoc ml5">info</mat-icon>
                </div>
            </ng-container>

            <div class="offerinfodet" (click)="gotoOffers()">
                <span multilang class="minbtn noselect" matRipple>Mehr Details</span>
            </div>
        </div>
        <div class="offerprice" (click)="goToBooking()">
            <div style="display: flex;">
                <div class="offerinfodet">
                    <mat-icon class="infoc">check_circle</mat-icon>
                    <span multilang style="margin-left: .3rem;">{{offer?.features?.gearbox === 'm' ?
                        'Schaltgetriebe' :
                        'Automatikgetriebe'}}</span>
                </div>
                <ng-container *ngIf="offer?.filters?.trg?.filterList?.length > 0">
                    <div class="offerinfodet" style="margin-left: .5rem;">
                        <mat-icon class="infoc">check_circle</mat-icon>
                        <span multilang style="margin-left: .3rem;">{{offer.filters.trg.filterList[0].name}}
                            <mat-icon class="infoc" style="cursor:help;color: gray;" #tooltipsofferpack="matTooltip"
                                (click)="tooltipsofferpack.toggle();$event.stopPropagation();"
                                matTooltipClass="matTooltip"
                                [matTooltip]="offer.filters.trg.filterList[0]?.description">info
                            </mat-icon></span>
                    </div>
                </ng-container>
            </div>
            <div class="offerpriceTotal">
                <span multilang>Gesamtpreis:</span>
                <span multilang class="prccolor">{{offer?.totalPrice?.value | number:'1.2-2'}} EUR</span>
            </div>
        </div>
        <div class="mhrd">
            <div class="noselect bookingbtn" (click)="goToBooking()">
                Buchen
            </div>
        </div>
    </div>
</div>